import React, { Component } from "react";
import { Table, Button, Modal, Col, Row, message, Tooltip, Select, Input, Menu, Dropdown, Icon } from "antd";
import axios from "axios";
import "./Pages.css";
import PedidoFiltroForm from '../components/PedidoFiltroForm';
import NotasFiscaisEmissaoPrintModal from "../relatorios/NotasFiscaisEmissaoPrintModal";
import NotaFiscalEmissaoForm from '../components/NotaFiscalEmissaoForm';
import NotaFiscalServicoEmissaoForm from '../components/NotaFiscalServicoEmissaoForm';
import JustificativaModalForm from '../components/JustificativaModalForm';
import ModalPadraoForm from '../components/ModalPadraoForm';
import SpinnerForm from '../components/SpinnerForm';
import moment from "moment-timezone";
import numeral from "numeral";
import { getUsuario, getTemPermissao } from "../utils/LoginManager";
import Colors from '../utils/Colors';
import LancNotasFiscais from '../tutoriais/LancNotasFiscais';


const { Column } = Table;
const ButtonGroup = Button.Group;
const { Option } = Select;
const { Search } = Input;

// Checagem local da chave da NF-e/NFC-e (não verifica autorização na SEFAZ).
const validarChaveAcessoNota = (chave, nota) => {
  // NFS-e (modelo 99) não usa a estrutura de 44 dígitos da NF-e/NFC-e.
  // Para NFS-e apenas exigimos uma chave não vazia; a chave pode ser
  // numérica ou alfanumérica conforme o provedor/padrão utilizado.
  if (nota && Number(nota.nf_modelo) === 99) {
    if (!String(chave || '').trim()) {
      return 'Informe a chave da NFS-e.';
    }
    if (String(chave).length > 80) {
      return 'A chave da NFS-e deve possuir no máximo 80 caracteres.';
    }
    return '';
  }

  if (!/^[0-9]{44}$/.test(chave)) {
    return 'Informe uma chave de acesso com exatamente 44 dígitos numéricos.';
  }

  // Código IBGE de UF: primeiros dois dígitos da chave.
  const codigosUF = [
    '11', '12', '13', '14', '15', '16', '17',
    '21', '22', '23', '24', '25', '26', '27', '28', '29',
    '31', '32', '33', '35',
    '41', '42', '43',
    '50', '51', '52', '53',
  ];
  if (!codigosUF.includes(chave.slice(0, 2))) {
    return 'O código da UF informado na chave de acesso é inválido.';
  }

  const mesEmissao = Number(chave.slice(4, 6));
  if (mesEmissao < 1 || mesEmissao > 12) {
    return 'O mês de emissão informado na chave de acesso é inválido.';
  }

  // DV da posição 44: módulo 11, pesos de 2 a 9, da direita para a esquerda.
  let soma = 0;
  let peso = 2;
  for (let i = 42; i >= 0; i -= 1) {
    soma += Number(chave[i]) * peso;
    peso = peso === 9 ? 2 : peso + 1;
  }
  const resto = soma % 11;
  const digitoEsperado = resto === 0 || resto === 1 ? 0 : 11 - resto;
  if (Number(chave[43]) !== digitoEsperado) {
    return `Dígito verificador (DV) inválido. Confira a chave digitada; o DV esperado é ${digitoEsperado}.`;
  }

  if (!nota) return '';

  if (Number(chave.slice(20, 22)) !== Number(nota.nf_modelo)) {
    return `O modelo da chave (${chave.slice(20, 22)}) não corresponde ao modelo da nota (${nota.nf_modelo}).`;
  }

  if (nota.nf_serie !== null && nota.nf_serie !== undefined && String(nota.nf_serie).trim() !== '' &&
    Number(chave.slice(22, 25)) !== Number(nota.nf_serie)) {
    return `A série da chave (${Number(chave.slice(22, 25))}) não corresponde à série da nota (${nota.nf_serie}).`;
  }

  if (nota.nf_numero !== null && nota.nf_numero !== undefined && String(nota.nf_numero).trim() !== '' &&
    Number(nota.nf_numero) > 0 && Number(chave.slice(25, 34)) !== Number(nota.nf_numero)) {
    return `O número da chave (${Number(chave.slice(25, 34))}) não corresponde ao número da nota (${nota.nf_numero}).`;
  }

  const cnpjEmitente = String(nota.enf_cnpj || '').replace(/\D/g, '');
  if (/^[0-9]{14}$/.test(cnpjEmitente) && chave.slice(6, 20) !== cnpjEmitente) {
    return 'O CNPJ do emitente presente na chave não corresponde ao emitente desta nota.';
  }

  return '';
};




export default class extends Component {
  state = {
    listaRegistros: [],
    carregandoLista: false,
    carregando: false,
    pagina: 1,
    limite: 10,
    total: 0,
    totalNF: 0,
    qtdeNF: 0,

    formEmissaoProdVisivel: false,
    formEmissaoServVisivel: false,
    formFiltroVisivel: false,
    formPrintOSVisivel: false,
    formPrintCupomVisivel: false,
    formPrint2ViasVisivel: false,
    formJustifVisivel: false,
    modalChaveVisivel: false,
    registroChaveSelecionado: null,
    chaveDigitada: '',
    salvandoChave: false,
    modalListaVisible: false,

    idfOS: 0,

    telaJustif: '',
    justificativa: '',

    registroSelecionado: [],
    registroSelecionadoJustif: [],
    registroSelecionadoCC: [],

    filtros: {
      tipoTela: 'EMINF',
      buscaOrdem: { campo: 'nf_dt_emissao', ordem: 'DESC' },
      buscaDataIni: moment(new Date(new Date().getFullYear(), new Date().getMonth() - 2, 1)).format('DD/MM/YYYY'),
      buscaDataFim: moment(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).format('DD/MM/YYYY'),
      buscaControle: '',
      buscaPessoa: { key: '0', },
      buscaProduto: { key: '0', },
      buscaGrupoProduto: { key: '0', },
      buscaMarcaProduto: { key: '0', },
      buscaServico: { key: '0', },
      buscaUsuario: { key: '0', },
      buscaStatusNF: { key: 'X', },
      buscaSitFin: { key: 'X', },
      buscaModeloNF: { key: 'X', },
      buscaVeiculo: '',
    }


  };


  componentDidMount() {
    const usuario = getUsuario();
    this.setState({ usuario }, this.getListaRegistros);
  }

  componentDidUpdate(antProps, antState) {
    const { total, pagina, limite } = this.state;
    const ultimaPagina = Math.ceil(total / limite);
    if (pagina > 1 && pagina > ultimaPagina) {
      this.setState({
        pagina: ultimaPagina
      }, this.getListaRegistros)
    }
  }



  getListaRegistros = () => {
    this.setState({ listaRegistros: [], carregandoLista: true, totalNF: 0, qtdeNF: 0 });
    const { pagina, limite } = this.state;
    const { buscaDataIni, buscaDataFim, buscaControle, buscaPessoa, buscaUsuario, buscaStatusNF, buscaSitFin, buscaModeloNF, buscaOrdem } = this.state.filtros;

    let dataIni = '';
    if ((buscaDataIni) && (buscaDataIni !== undefined)) {
      dataIni = moment(buscaDataIni, 'DD/MM/YYYY').format('YYYY-MM-DD');
    }
    let dataFim = '';
    if ((buscaDataFim) && (buscaDataFim !== undefined)) {
      dataFim = moment(buscaDataFim, 'DD/MM/YYYY').format('YYYY-MM-DD');
    }

    axios
      .get('/notas_fiscais', {
        params: {
          page: pagina,
          limite: limite,
          campoOrdem: buscaOrdem.campo,
          tipoOrdem: buscaOrdem.ordem,
          numero: buscaControle,
          pessoa: buscaPessoa.key,
          usuario: buscaUsuario.key,
          modelo: String(buscaModeloNF.key),
          sitFin: String(buscaSitFin.key),
          sitVen: String(buscaStatusNF.key),
          dataIni,
          dataFim,
        }
      })
      .then(response => {
        const { data, total, current_page, per_page } = response.data.dados;
        this.setState({
          listaRegistros: data,
          carregandoLista: false,
          total: total,
          pagina: current_page,
          limite: Number(per_page),

          totalNF: response.data.totalNF,
          qtdeNF: response.data.qtdeNF,
        });
      })
      .catch(erro => {
        console.warn(erro);
        this.setState({
          carregandoLista: false,
        });
      });
  };



  // Mostra a mensagem da API sem descartar os erros individuais de cada item.
  exibirErroEmissaoNF = (erroOuResposta, registro) => {
    const resposta = erroOuResposta && erroOuResposta.response
      ? erroOuResposta.response.data
      : erroOuResposta;
    const dados = resposta && typeof resposta === 'object' ? resposta : {};
    const status = dados.status !== undefined && dados.status !== null
      ? String(dados.status)
      : '';
    const ehErroDados = status === '5001' || status === '5002';
    const mensagemServidor = typeof dados.mensagem === 'string'
      ? dados.mensagem
      : (typeof resposta === 'string' ? resposta : '');
    const listaErros = Array.isArray(dados.erros) ? dados.erros : [];
    const mensagem = mensagemServidor || (
      erroOuResposta && erroOuResposta.message
        ? erroOuResposta.message
        : 'Não foi possível concluir a operação. Verifique os dados e tente novamente.'
    );

    Modal.error({
      title: ehErroDados ? 'Dados inválidos na Nota Fiscal' : 'Erro na emissão da Nota Fiscal',
      okText: 'OK',
      width: 740,
      style: { maxWidth: 'calc(100vw - 32px)' },
      content: (
        <div style={{ maxHeight: '60vh', overflowY: 'auto', overflowX: 'hidden', paddingRight: 8 }}>
          <p>
            {registro.transmitir
              ? 'Não foi possível transmitir a nota. Corrija os problemas abaixo e tente emitir novamente.'
              : 'Não foi possível gravar a nota. Verifique o erro abaixo e tente novamente.'}
          </p>
          {dados.nfe !== undefined && dados.nfe !== null && String(dados.nfe) !== ''
            ? <div><strong>NFe:</strong> {dados.nfe}</div>
            : null}
          {dados.chave ? <div><strong>Chave:</strong> {dados.chave}</div> : null}
          {status ? <div><strong>Código do erro:</strong> {status}</div> : null}
          <div style={{ marginTop: 10, whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>
            <strong>Mensagem: </strong>{mensagem}
          </div>
          {listaErros.length > 0 ? (
            <div style={{ marginTop: 12 }}>
              <strong>Campos que precisam de correção:</strong>
              <ul style={{ paddingLeft: 22, marginTop: 6 }}>
                {listaErros.map((erro, indice) => (
                  <li key={indice} style={{ marginBottom: 8, whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>
                    {typeof erro === 'string'
                      ? erro
                      : (erro.mensagem || [erro.campo || erro.erro, erro.descricao].filter(Boolean).join(' - ') || JSON.stringify(erro))}
                  </li>
                ))}
              </ul>
            </div>
          ) : null}
        </div>
      ),
    });
  };

  onSalvarClick = (registro) => {
    this.setState({ salvando: true });

    const request = registro.nf_idf
      ? axios.put(`/notas_fiscais/update/${registro.nf_idf}`, registro)
      : axios.post('/notas_fiscais/store', registro);

    request
      .then(response => {
        const dados = response.data;

        // Mesmo que um intermediário retorne HTTP 200/201, não tratar sucesso:false como nota emitida.
        if (!dados || typeof dados !== 'object' || dados.sucesso === false || dados.sucesso === 0) {
          this.setState({ salvando: false });
          this.exibirErroEmissaoNF(dados || response, registro);
          if (!registro.nf_idf && dados && dados.idfNF) {
            this.onEditarClick({ nf_idf: dados.idfNF }, false);
          }
          this.getListaRegistros();
          return;
        }

        this.setState({
          formEmissaoProdVisivel: false,
          formEmissaoServVisivel: false,
          salvando: false,
        });

        if (registro.transmitir && dados.pendente) {
          Modal.info({
            title: 'Nota fiscal em processamento',
            okText: 'OK',
            width: 520,
            content: (
              <div>
                <div>NFe: {dados.nfe}</div>
                <div>{dados.mensagem || 'A SEFAZ ainda está processando a nota. Consulte a situação antes de reenviar.'}</div>
              </div>
            ),
          });
        } else if (registro.transmitir) {
          Modal.success({
            title: 'Nota Fiscal',
            okText: 'OK',
            width: 520,
            content: (
              <div>
                <div>Nota TRANSMITIDA com sucesso</div>
                <div>NFe: {dados.nfe}</div>
                {dados.chave ? <div>Chave: {dados.chave}</div> : null}
              </div>
            ),
          });
        } else {
          message.success('Nota gravada com sucesso');
        }
        this.getListaRegistros();
      })
      .catch(error => {
        console.error('Erro ao gravar/transmitir NF:', error.response || error);
        // Não fechar o formulário: o usuário precisa corrigir os produtos e tentar novamente.
        this.setState({ salvando: false });
        this.exibirErroEmissaoNF(error, registro);

        const dados = error.response && error.response.data;
        // No POST a nota já pode ter sido gravada antes de a transmissão falhar.
        // Reabrir pelo ID salvo evita criar uma nova NF em cada tentativa de correção.
        if (!registro.nf_idf && dados && typeof dados === 'object' && dados.idfNF) {
          this.onEditarClick({ nf_idf: dados.idfNF }, false);
        }
        this.getListaRegistros();
      });
  };


  // Alteração manual da chave da NF-e/NFC-e/NFS-e.
  onAbrirAlterarChaveClick = (registro) => {
    this.setState({
      modalChaveVisivel: true,
      registroChaveSelecionado: registro,
      chaveDigitada: registro.nf_chave || '',
      salvandoChave: false,
    });
  };

  onCancelarAlterarChaveClick = () => {
    if (this.state.salvandoChave) return;
    this.setState({
      modalChaveVisivel: false,
      registroChaveSelecionado: null,
      chaveDigitada: '',
    });
  };

  onSalvarAlterarChaveClick = () => {
    const { registroChaveSelecionado, chaveDigitada, salvandoChave } = this.state;
    if (!registroChaveSelecionado || salvandoChave) return;

    const chave = String(chaveDigitada || '').replace(/\s/g, '');
    const mensagemValidacao = validarChaveAcessoNota(chave, registroChaveSelecionado);
    if (mensagemValidacao) {
      Modal.warning({
        title: 'Chave de acesso inválida',
        content: mensagemValidacao,
        okText: 'OK',
      });
      return;
    }

    if (chave === String(registroChaveSelecionado.nf_chave || '')) {
      this.onCancelarAlterarChaveClick();
      return;
    }

    this.setState({ salvandoChave: true });
    axios.put(`/notas_fiscais/update/${registroChaveSelecionado.nf_idf}`, {
      atualizarSomenteChave: true,
      nf_chave: chave,
    })
      .then(response => {
        const dados = response.data || {};
        if (dados.sucesso === false || dados.sucesso === 0) {
          throw new Error(dados.mensagem || 'Não foi possível atualizar a chave da nota.');
        }
        this.setState({
          modalChaveVisivel: false,
          registroChaveSelecionado: null,
          chaveDigitada: '',
          salvandoChave: false,
        });
        message.success(dados.mensagem || 'Chave de acesso atualizada com sucesso.');
        this.getListaRegistros();
      })
      .catch(error => {
        const dados = error.response && error.response.data;
        const descricao = dados && typeof dados === 'object'
          ? (dados.mensagem || dados.message)
          : (typeof dados === 'string' ? dados : error.message);
        this.setState({ salvandoChave: false });
        Modal.error({
          title: 'Erro ao atualizar a chave de acesso',
          content: descricao || 'Não foi possível salvar a chave. Tente novamente.',
          okText: 'OK',
          width: 540,
        });
      });
  };

  onEditarClick = (registro, visualizar) => {
    this.setState({ carregando: true });
    axios.get(`/notas_fiscais/show/${registro.nf_idf}`)
      .then(response => {
        const { data } = response;

        data.dados.nf_dt_inclusao = moment(data.dados.nf_dt_inclusao, 'YYYY-MM-DD').format('DD/MM/YYYY');
        data.dados.nf_dt_emissao = moment(data.dados.nf_dt_emissao, 'YYYY-MM-DD').format('DD/MM/YYYY');

        data.dados.nf_destinatario = {
          key: String(data.dados.nf_destinatario),
          label: data.dados.pes_nome,
        };

        data.dados.nf_tipo_mov_nf = { key: String(data.dados.nf_tipo_mov_nf), label: '', };
        data.dados.nf_emitente = { key: String(data.dados.nf_emitente), label: '', };
        data.dados.nf_modelo = { key: String(data.dados.nf_modelo), label: '', };
        data.dados.nf_nat_oper = { key: String(data.dados.nf_nat_oper), label: '', };
        data.dados.nf_forma_pagamento = { key: String(data.dados.nf_forma_pagamento), label: '', };
        data.dados.nf_finalidade_emissao = { key: String(data.dados.nf_finalidade_emissao), label: '', };
        data.dados.nf_consumidor_final = { key: String(data.dados.nf_consumidor_final), label: '', };
        data.dados.nf_tipo_documento = { key: String(data.dados.nf_tipo_documento), label: '', };
        data.dados.nf_tipo_atendimento = { key: String(data.dados.nf_tipo_atendimento), label: '', };
        data.dados.nff_tipo = { key: String(data.dados.nff_tipo), label: '', };
        data.dados.nff_idf_transportadora = { key: data.dados.nff_idf_transportadora ? String(data.dados.nff_idf_transportadora) : '0', label: '', };

        data.dados.nf_cond_pagto = {
          key: (data.listaParcelas.length > 0 && data.listaParcelas[0].tit_cond_pagto) ? String(data.listaParcelas[0].tit_cond_pagto) : '',
          label: (data.listaParcelas.length > 0 && data.listaParcelas[0].cp_descricao) ? String(data.listaParcelas[0].cp_descricao) : '',
          qtdeParc: (data.listaParcelas.length > 0 && data.listaParcelas[0].cp_qtde_parc) ? String(data.listaParcelas[0].cp_qtde_parc) : '',
          parcAVista: (data.listaParcelas.length > 0 && data.listaParcelas[0].cp_parc_avista) ? String(data.listaParcelas[0].cp_parc_avista) : '',
        }

        data.dados.nf_tipo_doc = {
          key: (data.listaParcelas.length > 0 && data.listaParcelas[0].tparc_tipo_doc) ? String(data.listaParcelas[0].tparc_tipo_doc) : '',
          label: (data.listaParcelas.length > 0 && data.listaParcelas[0].td_descricao) ? String(data.listaParcelas[0].td_descricao) : '',
        }

        data.dados.visualizando = false;

        this.setState({
          formEmissaoProdVisivel: data.dados.nf_modelo.key !== '99',
          formEmissaoServVisivel: data.dados.nf_modelo.key === '99',
          registroSelecionado: {
            ...data,
            visualizar,
          },
          carregando: false,
        })
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          carregando: false,
        })
      })
  };


  onCancelarNFProdClick = () => {
    this.setState({
      formEmissaoProdVisivel: false
    })
  }

  onCancelarNFServClick = () => {
    this.setState({
      formEmissaoServVisivel: false
    })
  }

  onAdicionarNFProdClick = () => {
    this.setState({
      formEmissaoProdVisivel: true,
      visualizar: false,
      registroSelecionado: {
        dados: {
          nf_idf: 0,
          nf_numero: 0,
          nf_serie: 0,
          nf_status: 0,
          nf_tipo: 'NFe',
          situacao_nota: 'NOVA NFE',
          nf_tipo_mov_nf: { key: '', label: '', },
          nf_destinatario: { key: '0', label: '' },
          nf_obs_interna: '',
          nf_dt_emissao: moment().format('DD/MM/YYYY'),
          nf_dt_inclusao: moment().format('DD/MM/YYYY'),
          nf_chave: '',

          nf_emitente: { key: '', label: '', },
          nf_modelo: { key: '', label: '', },
          nf_nat_oper: { key: '', label: '', },
          nf_forma_pagamento: { key: '2', label: '', },
          nf_finalidade_emissao: { key: '1', label: '', },
          nf_consumidor_final: { key: '1', label: '', },
          nf_tipo_documento: { key: '1', label: '', },
          nf_tipo_atendimento: { key: '1', label: '', },

          nff_tipo: { key: '9', label: '', },
          nff_idf_transportadora: { key: '0', label: '', },
          nff_num_volumes: '',
          nff_especie: '',
          nff_marca: '',
          nff_qtde_vol: 0,
          nff_peso_bruto: 0,
          nff_peso_liquido: 0,

          nf_chave_rel: '',
          nfinf_texto: '',

          nf_vlr_total: 0,
          nf_vlr_cofins: 0,
          nf_vlr_desconto: 0,
          nf_vlr_frete: 0,
          nf_vlr_icms: 0,
          nf_vlr_icms_st: 0,
          nf_vlr_ii: 0,
          nf_vlr_ipi: 0,
          nf_vlr_outras_desp: 0,
          nf_vlr_pis: 0,
          nf_vlr_produtos: 0,
          nf_vlr_seguro: 0,
          nf_bc_icms: 0,
          nf_bc_icms_st: 0,


          nf_cond_pagto: {
            key: String(this.state.usuario.par_cond_pagto_padrao),
            label: this.state.usuario.td_descricao,
            qtdeParc: this.state.usuario.cp_qtde_parc,
            parcAVista: this.state.usuario.cp_parc_avista,
          },
          nf_tipo_doc: {
            key: String(this.state.usuario.par_doc_padrao),
            label: this.state.usuario.td_descricao,
          },


          listaProdutos: [],
          listaParcelas: [],
          listaNFRelacionadas: [],
          visualizando: false,
        }
      },
      registroParcela: {
        tparc_parcela: 0,
        tparc_data_parcela: '',
        tparc_tipo_doc: { key: '0' },
        tparc_conta_corrente: { key: '0' },
        tparc_valor: 0,
        tparc_situacao: { key: 'A', label: 'ABERTO', },
        tparc_obs: '',
        td_descricao: '',
        cc_descricao: '',
        situacao_parcela: '',
        pgto_vlr_desconto: 0,
        pgto_vlr_acrescimo: 0,
        pgto_vlr_pago: 0,
        pgto_vlr_restante: 0,
        pgto_data: '',
        pgto_cta_corrente: '',
      }

    })
  };


  onAdicionarNFServClick = () => {
    this.setState({
      formEmissaoServVisivel: true,
      visualizar: false,
      registroSelecionado: {
        dados: {
          nf_idf: 0,
          nf_numero: 0,
          nf_serie: 0,
          nf_status: 0,
          nf_modelo: 99,
          nf_tipo: 'NFSe',
          situacao_nota: 'NOVA NFSE',
          nf_destinatario: { key: '0', label: '' },
          nf_obs_interna: '',
          nf_dt_emissao: moment().format('DD/MM/YYYY'),
          nf_dt_inclusao: moment().format('DD/MM/YYYY'),
          nf_chave: '',

          nf_emitente: { key: '', label: '', },
          nf_modelo: 99,
          nfinf_texto: '',

          nf_vlr_produtos: 0,
          nf_vlr_desconto: 0,
          nf_vlr_total: 0,
          nf_vlr_iss: 0,
          nf_vlr_csll: 0,
          nf_vlr_inss: 0,
          nf_vlr_irrf: 0,

          nf_cond_pagto: {
            key: String(this.state.usuario.par_cond_pagto_padrao),
            label: this.state.usuario.td_descricao,
            qtdeParc: this.state.usuario.cp_qtde_parc,
            parcAVista: this.state.usuario.cp_parc_avista,
          },
          nf_tipo_doc: {
            key: String(this.state.usuario.par_doc_padrao),
            label: this.state.usuario.td_descricao,
          },


          listaServicos: [],
          listaParcelas: [],
          visualizando: false,
        }
      },
      registroParcela: {
        tparc_parcela: 0,
        tparc_data_parcela: '',
        tparc_tipo_doc: { key: '0' },
        tparc_conta_corrente: { key: '0' },
        tparc_valor: 0,
        tparc_situacao: { key: 'A', label: 'ABERTO', },
        tparc_obs: '',
        td_descricao: '',
        cc_descricao: '',
        situacao_parcela: '',
        pgto_vlr_desconto: 0,
        pgto_vlr_acrescimo: 0,
        pgto_vlr_pago: 0,
        pgto_vlr_restante: 0,
        pgto_data: '',
        pgto_cta_corrente: '',
      }

    })
  };






  //--------------------------------------------------------------------
  // CONTROLES
  //--------------------------------------------------------------------


  renderAcoes = (text, registro) => {
    return (
      <ButtonGroup size="default">
        <Dropdown overlay={
          <Menu >
            {getTemPermissao('NotasFiscaisEmissaoPage', 'editar') && ((registro.nf_status === 0) || (registro.nf_status === 2) || (registro.nf_status === 3)) ? (
              <Menu.Item key="1" onClick={() => this.onEditarClick(registro, false)} style={{ fontWeight: 'bold', fontSize: 15 }}><Icon type="edit" /> Editar Nota</Menu.Item>
            ) : (
              <Menu.Item key="1" onClick={() => this.onEditarClick(registro, true)} style={{ fontWeight: 'bold', fontSize: 15 }}><Icon type="eye" /> Visualizar Dados da Nota</Menu.Item>
            )}
            {getTemPermissao('NotasFiscaisEmissaoPage', 'editar') &&
              [55, 65, 99].includes(Number(registro.nf_modelo)) &&
              (this.state.usuario.usu_idf === 1) ? (
              <Menu.Item
                key="alterar-chave"
                onClick={() => this.onAbrirAlterarChaveClick(registro)}
                style={{ fontSize: 15 }}
              >
                <Icon type="key" /> Alterar Chave de Acesso
              </Menu.Item>
            ) : null}
            <Menu.Divider />
            {[55, 65, 99].includes(Number(registro.nf_modelo)) ? (
              <Menu.Item key="copiar-xml-integranotas" onClick={() => this.onCopiarXmlIntegraNotasClick(registro)} style={{ fontSize: 15 }}>
                <Icon type="copy" /> {[2, 3].includes(Number(registro.nf_status)) ? "Copiar XML para diagnostico" : "Copiar XML (IntegraNotas)"}
              </Menu.Item>
            ) : null}
            {registro.nf_chave && ((registro.nf_status === 1) || (registro.nf_status === 4)) ? (
              <Menu.Item key="2" onClick={() => this.onImprimirClick(registro)} style={{ fontSize: 15 }}><Icon type="printer" /> Imprimir DANFE</Menu.Item>
            ) : null}
            {registro.nf_chave && ((registro.nf_status === 1) || (registro.nf_status === 4)) ? (
              <Menu.Item key="3" onClick={() => this.onBaixarClick(registro)} style={{ fontSize: 15 }}><Icon type="download" /> Baixar XML</Menu.Item>
            ) : null}
            {registro.nf_chave && ((registro.nf_status === 1) || (registro.nf_status === 4)) ? (
              <Menu.Item key="enviar-email-whatsapp" onClick={() => this.onEmailClick(registro)} style={{ fontSize: 15 }}><Icon type="mail" /> Enviar por Email/WhatsApp</Menu.Item>
            ) : null}
            {registro.nf_chave ? (
              <Menu.Item key="4" onClick={() => this.onConsultaClick(registro)} style={{ fontSize: 15 }}><Icon type="sync" /> Consulta Status na SEFAZ</Menu.Item>
            ) : null}
            {registro.nf_chave && registro.nf_status === 1 ? (
              <Menu.Divider />
            ) : null}
            {registro.nf_chave && registro.nf_status === 1 && ((registro.nf_modelo === 55) || (registro.nf_modelo === 65)) ? (
              <Menu.SubMenu title={<span><Icon type="file-text" /> Carta de Correção</span>} style={{ fontSize: 15 }}>
                <Menu.Item onClick={() => this.onAbrirCartaCClick(registro)} style={{ fontSize: 15 }}><Icon type="form" /> Nova Carta de Correção</Menu.Item>
                <Menu.Item onClick={() => this.onListaCCClick(registro)} style={{ fontSize: 15 }}><Icon type="unordered-list" /> Lista de Cartas de Correção</Menu.Item>
              </Menu.SubMenu>
            ) : null}
            {registro.nf_chave && registro.nf_status === 1 && ((registro.nf_modelo === 55) || (registro.nf_modelo === 65)) ? (
              <Menu.Item key="7" onClick={() => this.onAbrirInutilizaClick(registro)} style={{ color: Colors.textRed, fontSize: 15 }}><Icon type="stop" /> Inutilizar</Menu.Item>
            ) : null}
            {registro.nf_chave && registro.nf_status === 1 ? (
              <Menu.Item key="8" onClick={() => this.onAbrirCancelClick(registro)} style={{ color: Colors.textRed, fontSize: 15 }}><Icon type="close-circle" /> Cancelar</Menu.Item>
            ) : null}
            {getTemPermissao('NotasFiscaisEmissaoPage', 'excluir') && ((registro.nf_status === 0) || (registro.nf_status === 2) || (registro.nf_status === 3)) ? (
              <Menu.Divider />
            ) : null}
            {getTemPermissao('NotasFiscaisEmissaoPage', 'excluir') && ((registro.nf_status === 0) || (registro.nf_status === 2) || (registro.nf_status === 3)) ? (
              <Menu.Item key="9" onClick={() => this.onExcluirClick(registro)} style={{ color: Colors.textRed, fontSize: 15 }}><Icon type="delete" /> Excluir</Menu.Item>
            ) : null}
          </Menu>
        } placement="bottomLeft">
          <Button type="primary" style={{ backgroundColor: Colors.primaryLight, borderColor: Colors.primaryLight }}><Icon type="bars" /></Button>
        </Dropdown>
      </ButtonGroup>
    );
  };


  onExcluirClick = registro => {
    Modal.confirm({
      title: 'Confirmação de Exclusão',
      content: `Deseja excluir este registro?`,
      okText: 'Sim',
      cancelText: 'Não',
      onOk: () => {
        this.setState({ carregandoLista: true });
        axios.delete(`/notas_fiscais/delete/${registro.nf_idf}`)
          .then(response => {
            const { listaRegistros, total } = this.state;
            const registroIndex = listaRegistros.findIndex(tar => tar.nf_idf === registro.nf_idf)
            listaRegistros.splice(registroIndex, 1);
            this.setState({
              listaRegistros: listaRegistros.concat([]),
              total: total - 1,
              carregandoLista: false,
            })

          }).catch(error => {
            console.error(error.response);
            this.setState({
              carregandoLista: false,
            })
            if (error.response.status === 412) {
              Modal.error({ title: 'Atenção', width: '25%', content: error.response.data, okText: 'OK', })
            } else {
              Modal.error({ title: 'Falha - Atenção!', width: '25%', content: 'Não foi possível excluir. ' + error.response.data, okText: 'OK', })
            }
          })
      }
    })
  };

  onImprimirClick = (registro) => {
    this.setState({ carregando: true });
    axios
      .get('/notas_fiscais/imprimir', {
        params: {
          emitente: registro.nf_emitente,
          idf: registro.nf_idf,
          chave: registro.nf_chave,
        }
      })
      .then(response => {
        const { data } = response;
        if (data.sucesso) {
          const file_url = 'https://api.fastgestor.plenasistemas.inf.br/image/emp' + this.state.usuario.emp_codigo + '/pdf/' + data.url;
          window.open(file_url, '_blank')
        } else {
          Modal.error({ title: 'Falha - Atenção!', width: '25%', content: 'Não foi possível IMPRIMIR. ' + data.mensagem, okText: 'OK', })
        }
        this.setState({
          carregando: false,
        })
      })
      .catch(error => {
        // console.log(error.response);
        Modal.error({ title: 'Erro ao Imprimir', width: '25%', content: error.response.data.mensagem, okText: 'OK', })
        this.setState({
          carregando: false,
        })
      })
  };

  // Copia o XML devolvido pela IntegraNotas; nao utiliza o XML armazenado localmente.
  onCopiarXmlIntegraNotasClick = async (registro) => {
    this.setState({ carregando: true });
    try {
      const response = await axios.get('/notas_fiscais/xml', {
        params: { idf: registro.nf_idf, copiar: 1 },
      });
      const dados = response.data || {};
      if (!dados.sucesso || !dados.xml) {
        throw new Error(dados.mensagem || 'A IntegraNotas nao retornou o XML.');
      }

      // O retorno da API e Base64 com o conteudo UTF-8 do XML.
      const xml = Buffer.from(dados.xml, 'base64').toString('utf8');
      if (!/^\s*(?:<\?xml\b|<[a-zA-Z_])/.test(xml)) {
        throw new Error('A IntegraNotas retornou um conteudo que nao corresponde a um XML.');
      }

      if (navigator.clipboard && navigator.clipboard.writeText) {
        try {
          await navigator.clipboard.writeText(xml);
        } catch (erroClipboard) {
          // Browser sem permissao de clipboard: tentar copia tradicional.
          if (!this.copiarTextoXmlFallback(xml)) throw erroClipboard;
        }
      } else if (!this.copiarTextoXmlFallback(xml)) {
        throw new Error('Nao foi possivel acessar a area de transferencia do navegador.');
      }

      if (dados.origem === 'preview_envio' || dados.origem === 'preview_atual') {
        Modal.info({
          title: 'XML copiado para diagnostico',
          okText: 'OK',
          width: 600,
          content: dados.mensagem || 'O preview foi copiado. Ele nao e o XML autorizado ou protocolado.',
        });
      } else {
        message.success(dados.origem === 'xml_rejeitado'
          ? 'XML preservado da rejeicao copiado para a area de transferencia.'
          : 'XML da IntegraNotas copiado para a area de transferencia.', 6);
      }
    } catch (error) {
      const retorno = error.response && error.response.data;
      const mensagemErro = (retorno && retorno.mensagem) || error.message || 'Erro ao consultar o XML.';
      const erros = retorno && Array.isArray(retorno.erros) ? retorno.erros : [];
      Modal.error({
        title: 'Nao foi possivel copiar o XML',
        width: 720,
        okText: 'OK',
        content: (
          <div style={{ maxHeight: '60vh', overflowY: 'auto', overflowWrap: 'break-word' }}>
            <div style={{ whiteSpace: 'pre-wrap' }}>{mensagemErro}</div>
            {erros.length > 0 ? (
              <ul style={{ marginTop: 10, paddingLeft: 20 }}>
                {erros.map((erro, indice) => <li key={indice}>
                  {typeof erro === 'string' ? erro :
                    [erro.campo, erro.erro, erro.descricao].filter(Boolean).join(' - ')}
                </li>)}
              </ul>
            ) : null}
            {retorno && retorno.json_atual ? (
              <div style={{ marginTop: 12 }}>
                <Button icon="copy" onClick={async () => {
                  try {
                    if (navigator.clipboard && navigator.clipboard.writeText) {
                      await navigator.clipboard.writeText(retorno.json_atual);
                    } else if (!this.copiarTextoXmlFallback(retorno.json_atual)) {
                      throw new Error('Copia indisponivel no navegador.');
                    }
                    message.success('JSON com dados atuais copiado para diagnostico.');
                  } catch (erroCopia) {
                    if (this.copiarTextoXmlFallback(retorno.json_atual)) {
                      message.success('JSON com dados atuais copiado para diagnostico.');
                    } else {
                      message.error('Nao foi possivel copiar o JSON.');
                    }
                  }
                }}>Copiar JSON atual para diagnostico</Button>
              </div>
            ) : null}
            <div style={{ marginTop: 10 }}>
              Se a IntegraNotas rejeitou o JSON antes de gerar o XML (5001/5002),
              pode nao existir XML dessa tentativa. Consulte os erros de campos e
              corrija os dados antes de tentar a emissao novamente.
            </div>
          </div>
        ),
      });
    } finally {
      this.setState({ carregando: false });
    }
  };

  copiarTextoXmlFallback = (texto) => {
    const campo = document.createElement('textarea');
    campo.value = texto;
    campo.setAttribute('readonly', '');
    campo.style.position = 'fixed';
    campo.style.top = '-9999px';
    document.body.appendChild(campo);
    campo.focus();
    campo.select();
    let copiado = false;
    try {
      copiado = document.execCommand('copy');
    } finally {
      document.body.removeChild(campo);
    }
    return copiado;
  };

  onBaixarClick = async (registro) => {
    // console.log('onBaixarClick')
    this.setState({ carregando: true });
    axios
      .get('/notas_fiscais/xml', {
        params: {
          emitente: registro.nf_emitente,
          idf: registro.nf_idf,
          chave: registro.nf_chave,
        }
      })
      .then(response => {
        const { data } = response;

        if (data.sucesso) {

          // console.log('onBaixarClick', data)
          const decodedString = Buffer.from(response.data.xml, 'base64').toString('utf-8');
          const blob = new Blob([decodedString], { type: 'application/xml' });

          // Cria um link 'a' para download
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = registro.nf_chave + '.xml';
          link.style.display = 'none'; // Oculta o link
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          Modal.success({
            title: 'XML Nota Fiscal',
            okText: 'OK',
            width: '25%',
            content: (
              <div>
                <div>NFe: {registro.nf_numero}</div>
                <div>XML gravado</div>
                <div>Chave: {data.chave}</div>
              </div>
            ),
          })

          this.getListaRegistros();
        } else {
          Modal.warning({
            title: 'XML Nota Fiscal',
            okText: 'OK',
            width: '25%',
            content: (
              <div>
                <div>NFe: {registro.nf_numero}</div>
                <div>{data.mensagem}</div>
                <div>Chave: {data.chave}</div>
              </div>
            ),
          })
        }
        this.setState({
          carregando: false,
        })
      })
      .catch(error => {
        // console.log(error.response);
        Modal.error({ title: 'Erro ao Consultar', width: '25%', content: error.response.data.mensagem, okText: 'OK', })
        this.setState({
          carregando: false,
        })
      })
  };

  onEmailClick = (registro) => {
    this.setState({ carregando: true });
    axios
      .get('/notas_fiscais/enviarNotaAutomatico/' + registro.nf_idf
        // .get('/notas_fiscais/enviarEmail', {
        // params: {
        //   emitente: registro.nf_emitente,
        //   idf: registro.nf_idf,
        //   chave: registro.nf_chave,
        // }
      )
      .then(response => {
        const { data } = response;
        if (data.sucesso) {
          Modal.success({
            title: 'Envio da Nota',
            okText: 'OK',
            width: '25%',
            content: (
              <div>
                <div>Email/WhatsApp enviado com sucesso</div>
                <div>{data.mensagem}</div>
              </div>
            ),
          })
          this.getListaRegistros();
        } else {
          Modal.warning({
            title: 'Envio da Nota',
            okText: 'OK',
            width: '25%',
            content: (
              <div>
                <div>Erro ao enviar Email/WhatsApp da NFe</div>
                <div>{data.mensagem}</div>
              </div>
            ),
          })
        }
        this.setState({
          carregando: false,
        })
      })
      .catch(error => {
        // console.log(error.response);
        Modal.error({ title: 'Erro ao enviar Email/WhatsApp', width: '25%', content: error.response, okText: 'OK', })
        this.setState({
          carregando: false,
        })
      })
  };

  onConsultaClick = (registro) => {
    this.setState({ carregando: true });
    axios
      .get('/notas_fiscais/consulta', {
        params: {
          emitente: registro.nf_emitente,
          idf: registro.nf_idf,
          chave: registro.nf_chave,
        }
      })
      .then(response => {
        const { data } = response;
        if (data.sucesso) {
          Modal.success({
            title: 'Status Nota Fiscal',
            okText: 'OK',
            width: '25%',
            content: (
              <div>
                <div>NFe: {registro.nf_numero}</div>
                <div>{data.mensagem}</div>
                <div>Chave: {data.chave}</div>
              </div>
            ),
          })
          this.getListaRegistros();
        } else {
          Modal.warning({
            title: 'Status Nota Fiscal',
            okText: 'OK',
            width: '25%',
            content: (
              <div>
                <div>NFe: {registro.nf_numero}</div>
                <div>{data.mensagem}</div>
                <div>Chave: {data.chave}</div>
              </div>
            ),
          })
        }
        this.setState({
          carregando: false,
        })
      })
      .catch(error => {
        // console.log(error.response);
        Modal.error({ title: 'Erro ao Consultar', width: '25%', content: error.response.data.mensagem, okText: 'OK', })
        this.setState({
          carregando: false,
        })
        this.getListaRegistros();
      })
  };





  onSEFAZClick = (registro) => {
    this.setState({ carregando: true });
    axios
      .get('/notas_fiscais/statusSEFAS')
      .then(response => {
        const { data } = response;
        if (data.sucesso) {
          Modal.success({
            title: 'Status Sefaz',
            okText: 'OK',
            width: '25%',
            content: (
              <div>
                <div>{data.mensagem}</div>
              </div>
            ),
          })
        } else {
          Modal.error({ title: 'Falha - Atenção!', width: '25%', content: 'Não foi possível Consultar o Status da SEFAZ. ' + data.mensagem, okText: 'OK', })
        }
        this.setState({
          carregando: false,
        })
      })
      .catch(error => {
        // console.log(error.response);
        Modal.error({ title: 'Erro ao Consultar', width: '25%', content: error.response.data.mensagem, okText: 'OK', })
        this.setState({
          carregando: false,
        })
      })
  };



  onAbrirCartaCClick = (registro) => {
    this.setState({
      telaJustif: 'CC',
      registroSelecionadoJustif: registro,
      formJustifVisivel: true,
    })
  }

  onAbrirCancelClick = (registro) => {
    this.setState({
      telaJustif: 'CANC',
      formJustifVisivel: true,
      registroSelecionadoJustif: registro,
    })
  }

  onAbrirInutilizaClick = (registro) => {
    this.setState({
      telaJustif: 'INUT',
      formJustifVisivel: true,
      registroSelecionadoJustif: registro,
    })
  }

  onSalvarJustifClick = (registro, justif) => {
    // console.log('onSalvarJustifClick', justif)
    // console.log('onSalvarJustifClick', registro)

    if (!justif) {
      Modal.warning({ title: 'Aviso!', width: '25%', content: 'Informe uma Justificativa', okText: 'OK', })
      return;
    }

    if (this.state.telaJustif === 'CANC') {

      this.setState({ carregando: true });
      const reg = {
        emitente: registro.nf_emitente,
        idf: registro.nf_idf,
        chave: registro.nf_chave,
        justf: justif,
      }
      axios.post(`/notas_fiscais/cancela`, reg)
        .then(response => {
          const { data } = response;

          // console.log('onSalvarJustifClick - cancela', data);

          if (data.sucesso) {
            Modal.success({
              title: 'Cancelamento Nota Fiscal',
              okText: 'OK',
              width: '25%',
              content: (
                <div>
                  <div>NFe: {registro.nf_numero}</div>
                  <div>{data.mensagem}</div>
                </div>
              ),
            })
            this.setState({
              carregando: false,
              telaJustif: '',
              formJustifVisivel: false
            })
            this.getListaRegistros();
          } else {
            Modal.warning({
              title: 'Cancelamento Nota Fiscal',
              okText: 'OK',
              width: '25%',
              content: (
                <div>
                  <div>NFe: {registro.nf_numero}</div>
                  <div>{data.mensagem}</div>
                </div>
              ),
            })
          }
          this.setState({
            carregando: false,
            telaJustif: '',
            formJustifVisivel: false
          })
        })
        .catch(error => {
          // console.log(error.response);
          Modal.error({ title: 'Erro ao Cancelar', width: '25%', content: error.response.data.mensagem, okText: 'OK', })
          this.setState({
            carregando: false,
            telaJustif: '',
            formJustifVisivel: false
          })
        })

    } else if (this.state.telaJustif === 'CC') {

      this.setState({ carregando: true });
      const reg = {
        emitente: registro.nf_emitente,
        idf: registro.nf_idf,
        chave: registro.nf_chave,
        justf: justif,
      }
      axios.post(`/notas_fiscais/cartacorrecao`, reg)
        .then(response => {
          const { data } = response;

          // console.log('onSalvarJustifClick - cartacorrecao', data);

          if (data.sucesso) {
            Modal.success({
              title: 'Carta de Correção Nota Fiscal',
              okText: 'OK',
              width: '25%',
              content: (
                <div>
                  <div>NFe: {registro.nf_numero}</div>
                  <div>{data.mensagem}</div>
                </div>
              ),
            })
            this.setState({
              carregando: false,
              telaJustif: '',
              formJustifVisivel: false
            })
            this.getListaRegistros();
          } else {
            Modal.warning({
              title: 'Carta de Correção Nota Fiscal',
              okText: 'OK',
              width: '25%',
              content: (
                <div>
                  <div>NFe: {registro.nf_numero}</div>
                  <div>{data.mensagem}</div>
                </div>
              ),
            })
          }
          this.setState({
            carregando: false,
            telaJustif: '',
            formJustifVisivel: false
          })
        })
        .catch(error => {
          // console.log(error.response);
          Modal.error({ title: 'Erro ao Gerar Carta de Correção', width: '25%', content: error.response.data.mensagem, okText: 'OK', })
          this.setState({
            carregando: false,
          })
        })

    } else if (this.state.telaJustif === 'INUT') {

      this.setState({ carregando: true });
      const reg = {
        emitente: registro.nf_emitente,
        idf: registro.nf_idf,
        serie: registro.nf_serie,
        num_ini: registro.nf_numero,
        num_fim: registro.nf_numero,
        justf: justif,
      }
      axios.post(`/notas_fiscais/inutiliza`, reg)
        .then(response => {
          const { data } = response;

          // console.log('onSalvarJustifClick - inutiliza', data);

          if (data.sucesso) {
            Modal.success({
              title: 'Inutiliza Nota Fiscal',
              okText: 'OK',
              width: '25%',
              content: (
                <div>
                  <div>NFe: {registro.nf_numero}</div>
                  <div>{data.mensagem}</div>
                </div>
              ),
            })
            this.setState({
              carregando: false,
              telaJustif: '',
              formJustifVisivel: false
            })
            this.getListaRegistros();
          } else {
            Modal.warning({
              title: 'Inutiliza Nota Fiscal',
              okText: 'OK',
              width: '25%',
              content: (
                <div>
                  <div>NFe: {registro.nf_numero}</div>
                  <div>{data.mensagem}</div>
                </div>
              ),
            })
          }
          this.setState({
            carregando: false,
            telaJustif: '',
            formJustifVisivel: false
          })
        })
        .catch(error => {
          // console.log(error.response);
          Modal.error({ title: 'Erro ao Inutilizar', width: '25%', content: error.response.data.mensagem, okText: 'OK', })
          this.setState({
            carregando: false,
            telaJustif: '',
            formJustifVisivel: false
          })
        })

    } else {
      this.setState({
        telaJustif: '',
        formJustifVisivel: true
      })
    }

  }

  onCancelarJustifClick = () => {
    this.setState({
      justificativa: '',
      formJustifVisivel: false
    })
  }









  onAbrirFiltroClick = () => {
    this.setState({
      formFiltroVisivel: true,
      filtros: {
        tipoTela: this.state.filtros.tipoTela,
        buscaOrdem: this.state.filtros.buscaOrdem,
        buscaDataIni: this.state.filtros.buscaDataIni,
        buscaDataFim: this.state.filtros.buscaDataFim,
        buscaControle: String(this.state.filtros.buscaControle),
        buscaUsuario: this.state.filtros.buscaUsuario,
        buscaPessoa: this.state.filtros.buscaPessoa,
        buscaProduto: this.state.filtros.buscaProduto,
        buscaGrupoProduto: this.state.filtros.buscaGrupoProduto,
        buscaMarcaProduto: this.state.filtros.buscaMarcaProduto,
        buscaServico: this.state.filtros.buscaServico,
        buscaStatusNF: this.state.filtros.buscaStatusNF,
        buscaSitFin: this.state.filtros.buscaSitFin,
        buscaModeloNF: this.state.filtros.buscaModeloNF,
        buscaVeiculo: this.state.filtros.buscaVeiculo,
      }
    })
  };

  onFiltrarClick = (filtros) => {
    this.setState({
      formFiltroVisivel: false,
      filtros,
    },
      this.getListaRegistros(filtros)
    )
  };

  onCancelarFiltroClick = () => {
    this.setState({
      formFiltroVisivel: false,
    })
  };




  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;
    this.setState({ [id]: value });
  };

  onOrdenarListaClick = (column) => {
    const { filtros } = this.state;
    const ordem = filtros.buscaOrdem.campo && filtros.buscaOrdem.campo === column.dataIndex ? (filtros.buscaOrdem.ordem && filtros.buscaOrdem.ordem === 'ASC' ? 'DESC' : 'ASC') : 'ASC';
    filtros['buscaOrdem'] = { campo: column.dataIndex, ordem };
    this.setState({
      filtros,
      pagina: 1,
    }, this.getListaRegistros)
  };

  renderTitulo = (col) => {
    return (
      <Tooltip title="Clique para Ordenar"><div style={{ background: "#ececec", cursor: 'pointer', padding: 2, marginLeft: -5, marginRight: -5 }}>{col}</div></Tooltip>
    );
  };


  renderDataHora = (data) => {
    if (data) {
      const dataMoment = moment(data);
      return (
        <span>
          {dataMoment.format('DD/MM/YYYY HH:mm')}
        </span>
      )
    } else {
      return (
        <span></span>
      )
    }
  }

  renderModelo = (nfe, registro) => {
    return (
      <span> {nfe === 55 ? 'NFe' : nfe === 65 ? 'NFCe' : 'Serv'} </span>
    );
  };

  renderNumero = (nfe, registro) => {
    return (
      <Tooltip title={registro.nf_chave ? 'Chave: ' + registro.nf_chave : null}>
        <span> {nfe} </span>
      </Tooltip>
    );
  };

  renderValor = (vlr, registro) => {
    return (
      <span> {numeral(parseFloat(vlr)).format('0,000.00')} </span>
    );
  };



  onListaCCClick = (registro) => {
    this.setState({
      modalListaVisible: true,
      tipoTela: 'CC',
      registroSelecionadoCC: registro,
    });
  }

  onFecharModalLista = () => {
    this.setState({
      modalListaVisible: false,
    });
  }



  onTabelaChange = (pagination => {
    this.setState({
      pagina: pagination.current,
      limite: pagination.pageSize,
    },
      this.getListaRegistros)
  })

  renderVendedor = (usu_nome) => {
    return (
      <span>{usu_nome.substring(0, 10)}</span>
    );
  };


  onBuscar = (texto) => {
    this.setState({
      filtros: {
        tipoTela: this.state.filtros.tipoTela,
        buscaOrdem: this.state.filtros.buscaOrdem,
        buscaDataIni: this.state.filtros.buscaDataIni,
        buscaDataFim: this.state.filtros.buscaDataFim,
        buscaControle: String(texto),
        buscaUsuario: this.state.filtros.buscaUsuario,
        buscaPessoa: this.state.filtros.buscaPessoa,
        buscaProduto: this.state.filtros.buscaProduto,
        buscaGrupoProduto: this.state.filtros.buscaGrupoProduto,
        buscaMarcaProduto: this.state.filtros.buscaMarcaProduto,
        buscaServico: this.state.filtros.buscaServico,
        buscaStatusNF: this.state.filtros.buscaStatusNF,
        buscaSitFin: this.state.filtros.buscaSitFin,
        buscaModeloNF: this.state.filtros.buscaModeloNF,
        buscaVeiculo: this.state.filtros.buscaVeiculo,
      }
    },
      this.getListaRegistros);
  };



  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------


  render() {
    const { listaRegistros, carregando, carregandoLista, formEmissaoProdVisivel, formEmissaoServVisivel, formJustifVisivel, salvando, modalListaVisible, tipoTela,
      registroSelecionado, registroSelecionadoJustif, registroSelecionadoCC, filtros, formFiltroVisivel, total, pagina, limite } = this.state;
    const { buscaControle } = this.state.filtros;

    // console.log('NotasFiscaisEmissaoPage.this.state: ', this.state);

    return (
      <div className="contentRoutesContainer">

        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <span className="tituloPage">Notas Fiscais</span>
          <div>
            <Tooltip title="Video de Ajuda - Nota de Produtos">
              <Button
                type="primary"
                onClick={() => window.open('https://www.youtube.com/watch?v=T9s-VeRas14&list=PLpe5WZ31yjQa5k3LuG7hBzmY1J-mOW3zz&index=3', '_blank')}
                icon="youtube"
                className="botao-ajuda"
              ></Button>
            </Tooltip>
            <Tooltip title="Video de Ajuda - Nota de Serviços">
              <Button
                type="primary"
                onClick={() => window.open('https://www.youtube.com/watch?v=9gyi9kzIFGs&list=PLpe5WZ31yjQa5k3LuG7hBzmY1J-mOW3zz&index=4', '_blank')}
                icon="youtube"
                className="botao-ajuda"
              ></Button>
            </Tooltip>
            <Tooltip title="Ajuda">
              <Button
                type="primary"
                onClick={() => this.setState({ modalOpen: true })}
                icon="question"
                className="botao-ajuda"
              ></Button>
            </Tooltip>
          </div>
        </div>
        <div className="divider-page1" />

        <div className="pageFiltro" style={{ height: 50 }}>
          <Col xs={24} >
            <Col xs={24}>
              {getTemPermissao('NotasFiscaisEmissaoPage', 'novo') ? (
                <Col xs={2} style={{ width: 150 }}>
                  <Tooltip title='Nova Nota de Produtos'>
                    <Button
                      type="primary"
                      onClick={this.onAdicionarNFProdClick}
                      className="botao-primary"
                      style={{ width: '90%' }}
                    >
                      Nota de Produto
                    </Button>
                  </Tooltip>
                </Col>
              ) : null}

              {getTemPermissao('NotasFiscaisEmissaoPage', 'novo') ? (
                <Col xs={2} style={{ width: 150 }}>
                  <Tooltip title='Nova Nota de Serviços'>
                    <Button
                      type="primary"
                      onClick={this.onAdicionarNFServClick}
                      className="botao-primary"
                      style={{ width: '90%' }}
                    >
                      Nota de Serviço
                    </Button>
                  </Tooltip>
                </Col>
              ) : null}

              <Col xs={2} style={{ width: 110 }}>
                <Button
                  type="primary"
                  onClick={this.onAbrirFiltroClick}
                  className="botao-primary"
                  style={{ marginRight: 15 }}
                >
                  Filtrar
                </Button>
              </Col>

              <Col xs={2} style={{ width: 110 }}>
                <Tooltip title='Consultar Status Da SEFAZ'>
                  <Button
                    type="primary"
                    onClick={this.onSEFAZClick}
                    className="botao-primary"
                    style={{ marginRight: 15 }}
                  >
                    SEFAZ
                  </Button>
                </Tooltip>
              </Col>

              <Col xs={2} style={{ width: 110 }}>
                <NotasFiscaisEmissaoPrintModal
                  filtros={filtros}
                  totalNF={this.state.totalNF}
                  qtdeNF={this.state.qtdeNF}
                />
              </Col>

              <Col xs={6}>
                <Search
                  placeholder="Nº NF"
                  onSearch={this.onBuscar}
                  enterButton
                  className="pageFiltro-busca"
                />
              </Col>

            </Col>


            <Col xs={24} style={{ height: 65, padding: 5, marginTop: 10, marginBottom: 10, display: 'flex', justifyContent: 'center' }}>
              <Col xs={24} md={6} style={{ height: 65, padding: 5 }}>
                <div style={{ height: "100%", borderStyle: "outset", borderWidth: 2, borderRadius: 5, backgroundColor: "white" }}>
                  <Row style={{ textAlign: "center", marginTop: 0, marginBottom: 5 }}>
                    <span style={{ fontSize: 17, fontWeight: "bold", color: Colors.primary }}>
                      Qtde NF
                    </span>
                  </Row>
                  <Row style={{ textAlign: "center" }}>
                    <Row style={{ marginTop: -5 }}>
                      <span style={{ fontSize: 14, fontWeight: "bold", color: "rgba(0, 0, 0, 0.45)" }}>{this.state.qtdeNF}</span>
                    </Row>
                  </Row>
                </div>
              </Col>
              <Col xs={24} md={6} style={{ height: 65, padding: 5 }}>
                <div style={{ height: "100%", borderStyle: "outset", borderWidth: 2, borderRadius: 5, backgroundColor: "white" }}>
                  <Row style={{ textAlign: "center", marginTop: 0, marginBottom: 5 }}>
                    <span style={{ fontSize: 17, fontWeight: "bold", color: Colors.primary }}>
                      Valor Total
                    </span>
                  </Row>
                  <Row style={{ textAlign: "center" }}>
                    <Row style={{ marginTop: -5 }}>
                      <span style={{ fontSize: 14, fontWeight: "bold", color: "rgba(0, 0, 0, 0.45)" }}>{this.renderValor(this.state.totalNF)}</span>
                    </Row>
                  </Row>
                </div>
              </Col>
            </Col>

          </Col>

          <NotaFiscalEmissaoForm
            visivel={formEmissaoProdVisivel}
            onSalvarClick={this.onSalvarClick}
            onCancelarNFProdClick={this.onCancelarNFProdClick}
            carregando={salvando}
            registroSelecionado={registroSelecionado}
          />

          <NotaFiscalServicoEmissaoForm
            visivel={formEmissaoServVisivel}
            onSalvarClick={this.onSalvarClick}
            onCancelarNFServClick={this.onCancelarNFServClick}
            carregando={salvando}
            registroSelecionado={registroSelecionado}
          />

          <Modal
            title="Informar / Alterar Chave de Acesso"
            visible={this.state.modalChaveVisivel}
            onOk={this.onSalvarAlterarChaveClick}
            onCancel={this.onCancelarAlterarChaveClick}
            okText="Salvar Chave"
            cancelText="Cancelar"
            confirmLoading={this.state.salvandoChave}
            okButtonProps={{ disabled: this.state.salvandoChave }}
            cancelButtonProps={{ disabled: this.state.salvandoChave }}
            closable={!this.state.salvandoChave}
            maskClosable={false}
            destroyOnClose
            width={620}
          >
            {this.state.registroChaveSelecionado ? (
              <div>
                <p>
                  <strong>Nota:</strong> {this.state.registroChaveSelecionado.nf_numero}
                  {' / Série: '}{this.state.registroChaveSelecionado.nf_serie}
                  {' / Modelo: '}{this.state.registroChaveSelecionado.nf_modelo}
                </p>
                {Number(this.state.registroChaveSelecionado.nf_modelo) === 99 ? (
                  <React.Fragment>
                    <div style={{ marginBottom: 6 }}><strong>Chave da NFS-e</strong></div>
                    <Input
                      autoFocus
                      value={this.state.chaveDigitada}
                      placeholder="Digite ou cole a chave da NFS-e"
                      onChange={event => this.setState({ chaveDigitada: event.target.value })}
                      onPressEnter={this.onSalvarAlterarChaveClick}
                      disabled={this.state.salvandoChave}
                      maxLength={44}
                      style={{ fontSize: 15 }}
                    />
                    <div style={{ marginTop: 6, color: '#777' }}>
                      {String(this.state.chaveDigitada || '').length} / 44 caracteres
                    </div>
                    <p style={{ marginTop: 14, marginBottom: 0, color: '#a66a00' }}>
                      Para NFS-e a chave não será validada pela regra de 44 dígitos da NF-e/NFC-e.
                      A alteração grava somente a chave e não transmite novamente a nota nem altera sua situação fiscal.
                    </p>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <div style={{ marginBottom: 6 }}><strong>Chave de acesso (44 dígitos)</strong></div>
                    <Input
                      autoFocus
                      value={this.state.chaveDigitada}
                      placeholder="Digite ou cole a chave de acesso da nota"
                      onChange={event => this.setState({ chaveDigitada: event.target.value })}
                      onPressEnter={this.onSalvarAlterarChaveClick}
                      disabled={this.state.salvandoChave}
                      maxLength={44}
                      style={{ fontSize: 15 }}
                    />
                    <div style={{ marginTop: 6, color: '#777' }}>
                      {String(this.state.chaveDigitada || '').replace(/\s/g, '').length} / 44 dígitos
                    </div>
                    <p style={{ marginTop: 14, marginBottom: 0, color: '#a66a00' }}>
                      A chave será conferida pelo dígito verificador (DV), UF, mês, emitente,
                      modelo, série e número da nota. Isso não confirma autorização na SEFAZ.
                      A alteração não transmite a nota nem modifica a situação fiscal.
                    </p>
                  </React.Fragment>
                )}
              </div>
            ) : null}
          </Modal>

          <JustificativaModalForm
            visivel={formJustifVisivel}
            onSalvarJustifClick={this.onSalvarJustifClick}
            onCancelarJustifClick={this.onCancelarJustifClick}
            registroSelecionadoJustif={registroSelecionadoJustif}
          />

          <ModalPadraoForm
            visivel={modalListaVisible}
            telaModal={tipoTela}
            registroSelecionadoCC={registroSelecionadoCC}
            onFecharClick={this.onFecharModalLista}
          />

          <PedidoFiltroForm
            visivel={formFiltroVisivel}
            onFiltrarClick={this.onFiltrarClick}
            onCancelarFiltroClick={this.onCancelarFiltroClick}
            filtros={filtros}
          />

          <LancNotasFiscais
            isOpen={this.state.modalOpen}
            onClose={() => this.setState({ modalOpen: false })}
          />

          <SpinnerForm visivel={carregando} texto={'Carregando Aguarde...'} />
        </div>



        <div style={{}}>
          <Table
            pagination={{
              total: total,
              pageSize: limite,
              current: pagina,
              pageSizeOptions: ['10', '20', '30', '40'],
              showSizeChanger: true,
            }}
            onChange={this.onTabelaChange}
            loading={{
              spinning: carregandoLista,
              tip: 'Carregando. Aguarde...',
              size: "large"
            }}
            dataSource={listaRegistros}
            rowKey={(registro => registro.nf_idf)}
          // scroll={{ x: 600, y: false }}
          >
            <Column
              key="acoes"
              title={<div style={{ background: "#ececec", padding: 2, marginLeft: -5, marginRight: -5 }}>.</div>}
              render={this.renderAcoes}
              width={5}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="nf_dt_emissao"
              dataIndex="nf_dt_emissao"
              title={this.renderTitulo("Emissão")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              render={this.renderDataHora}
              width={140}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="enf_cnpj"
              dataIndex="enf_cnpj"
              title={this.renderTitulo("Emitente")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              width={140}
              align="left"
              className="listaCadastro"
            />
            <Column
              key="nf_tipo"
              dataIndex="nf_tipo"
              title={this.renderTitulo("Origem")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              width={80}
              align="left"
              className="listaCadastro"
            />
            <Column
              key="nf_modelo"
              dataIndex="nf_modelo"
              title={this.renderTitulo("Modelo")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              render={this.renderModelo}
              width={80}
              align="left"
              className="listaCadastro"
            />
            <Column
              key="nf_numero"
              dataIndex="nf_numero"
              title={this.renderTitulo("Número")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              render={this.renderNumero}
              width={80}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="pes_nome"
              dataIndex="pes_nome"
              title={this.renderTitulo("Remet/Dest")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              width={300}
              align="left"
              className="listaCadastro"
            />
            <Column
              key="nf_vlr_total"
              dataIndex="nf_vlr_total"
              title={this.renderTitulo("Valor Total")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              render={this.renderValor}
              width={140}
              align="right"
              className="listaCadastro"
            />
            <Column
              key="situacao_titulo"
              dataIndex="situacao_titulo"
              title={this.renderTitulo("Sit. Financ.")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              width={100}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="situacao_nota"
              dataIndex="situacao_nota"
              title={this.renderTitulo("Situação")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              width={100}
              align="left"
              className="listaCadastro"
            />

          </Table>
        </div>
      </div >
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/NotasFiscaisEmissaoPage.js